import { create } from 'zustand';

type TPayByBankSetupPhase = 'idle' | 'waiting' | 'failed';

interface IPayByBankSetupState {
	phase: TPayByBankSetupPhase;
	startedAt: number | null;
	startWaiting(): void;
	markFailed(): void;
	reset(): void;
}

export const usePayByBankSetupStore = create<IPayByBankSetupState>()(
	(set, get) => ({
		phase: 'idle',
		startedAt: null,
		startWaiting: () => {
			if (get().phase === 'waiting') return;
			set({ phase: 'waiting', startedAt: Date.now() });
		},
		markFailed: () => set({ phase: 'failed' }),
		reset: () => set({ phase: 'idle', startedAt: null }),
	})
);
